import React from "react";
import { Link } from "react-router-dom";

function Pnf() {
  return (
    <div className="container text-center mt-5">
      <h1 className="display-1 text-danger">404</h1>
      <h3>Page Not Found</h3>
      <p>The page you are looking for does not exist.</p>

      <Link to="/" className="btn btn-primary mt-3">
        Go to Home
      </Link>
    </div>
  );
}

export default Pnf;